import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export class Slider {
  constructor() {
    this.createSlider();
  }

  private createSlider() {

    const swiperQuote = new Swiper('.js-quote-slider', {
      modules: [Navigation, Pagination],

      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: '-48px',
      breakpoints: {
        1328: {
          spaceBetween: '-50%',
          slidesPerView: 1,
        },
        575.98: {
          spaceBetween: '-48px',
          slidesPerView: 'auto',
        }
      },
      loop: false,
      navigation: {
        nextEl: '.c-slider__quote-button--next',
        prevEl: '.c-slider__quote-button--prev',
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    }
  );
const swiper = new Swiper('.js-slider', {
      modules: [Navigation, Pagination],

      slidesPerView: 'auto',
      spaceBetween: 12,
      centeredSlides: false,

      // spaceBetween: 200,
      loop: false,
      navigation: {
        nextEl: '.c-slider__button--next',
        prevEl: '.c-slider__button--prev',
      },
      pagination: {
        el: '.c-slider__pagination',
        clickable: true,
        type: 'custom',
        renderCustom: function(swiper, current, total) {
          const pagination: HTMLElement = swiper.el.querySelector('.c-slider__pagination');
          const progress = Math.round((current / total * 100) * 100) / 100;
          pagination.style.setProperty('--progress', `${progress}%`);
          return null;
        }
      },
    });
  }
}

new Slider();
